<template>
  <div id="app">
    <router-view />
    <ConfirmActionModal
      :visible="registryConfirmationVisible"
      title="Conferma associazioni cliente"
      eyebrow="Anagrafica clienti"
      :message="registryConfirmationMessage"
      confirm-label="Associa e continua"
      cancel-label="Controlla i dati"
      icon-class="fa-solid fa-address-card"
      confirm-icon-class="fa-solid fa-link"
      tone="info"
      @close="closeRegistryConfirmation"
      @confirm="confirmRegistryAssociations"
    />
  </div>
</template>
<script>
import { theme } from "@/store/theme";
import ConfirmActionModal from "@/components/ConfirmActionModal.vue";

export default {
  name: "App",
  components: { ConfirmActionModal },
  data() {
    return {
      registryConfirmationVisible: false,
      registryConfirmationMessage: "",
      registryConfirmationCallback: null,
    };
  },
  mounted() {
    theme.apply(); // Applica il tema globale al caricamento dell'app
    window.addEventListener(
      "client-registry-confirmation-request",
      this.openRegistryConfirmation
    );
  },
  beforeDestroy() {
    window.removeEventListener(
      "client-registry-confirmation-request",
      this.openRegistryConfirmation
    );
  },
  methods: {
    openRegistryConfirmation(event) {
      this.registryConfirmationMessage = event.detail?.message || "";
      this.registryConfirmationCallback = event.detail?.onConfirm || null;
      this.registryConfirmationVisible = true;
    },
    closeRegistryConfirmation() {
      this.registryConfirmationVisible = false;
      this.registryConfirmationMessage = "";
      this.registryConfirmationCallback = null;
    },
    confirmRegistryAssociations() {
      const callback = this.registryConfirmationCallback;
      this.closeRegistryConfirmation();
      if (typeof callback === "function") callback();
    },
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: default;
}

body {
  background-color: #f9f9f9;
}
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
